import React from "react";
function Navigation() {
  const role = localStorage.getItem('role');
  return (
    <div>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <a className="brand-link">
          <span className="brand-text font-weight-light">
          Mango Tracking Co., LTD
            {/* <button onClick={handleLogout} className="btn btn-danger ml-2">
              Sign Out
            </button> */}
          </span>
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {role === '1' && (
                <>
                  <li className="nav-header">Master Report</li>
                  <li className="nav-item">
                    <a href="./IVMS" className="nav-link">
                      <i className="fas fa-circle nav-icon"></i>
                      <p>IVMS Report</p>
                    </a>
                  </li>
                </>
              )}

              {role === '2' && (
                <>
                  <li className="nav-header">RMA Report</li>
                  <li className="nav-item">
                    <a href="" className="nav-link">
                      <i className="nav-icon fas fa-circle"></i>
                      <p>
                        RMA Report
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </a>
                    <ul className="nav nav-treeview">
                      <li className="nav-item">
                        <a href="./overspeed" className="nav-link">
                          <i className="far fa-circle nav-icon"></i>
                          <p>OverSpeed Report</p>
                        </a>
                      </li>
                      
                      <li className="nav-item">
                      <a href="./idling" className="nav-link">
                          <i className="far fa-circle nav-icon"></i>
                          <p>Idling Report</p>
                        </a>
                      </li>
                      
                     
                    </ul>
                  </li>
                  
                </>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
}

export default Navigation;
